const shippingStatusQueryUrl = "v1/credit/cards/shipping-status";
export {
  shippingStatusQueryUrl
};
//# sourceMappingURL=endpoints.js.map
